import create from 'zustand'
import { GroundingReturn } from '../../../types/Grounding/GroundingResult'

interface IGroundingData {
  groundingData: GroundingReturn
  defaultGroundingData: GroundingReturn
  groundingCompletionData: GroundingReturn
  showTerms?: boolean
  alreadyConfirmRecall?: boolean
  alreadyConfirmGeneralModal?: boolean

  setGroundingData: (data: GroundingReturn) => void
  setDefaultGroundingData: (data: GroundingReturn) => void
  setGroundingCompletionData: (data: GroundingReturn) => void
  setShowTerms: (data: boolean) => void
  setAlreadyConfirmRecall: (data: boolean) => void
  setAlreadyConfirmGeneralModal: (data: boolean) => void
}

export const useGroundingStore = create<IGroundingData>((set, get) => ({
  groundingData: {} as GroundingReturn,
  defaultGroundingData: {} as GroundingReturn,
  groundingCompletionData: {} as GroundingReturn,
  showTerms: false,
  alreadyConfirmRecall: false,
  alreadyConfirmGeneralModal: false,

  setGroundingData: (data) => {
    set((state) => ({ ...state, groundingData: data }))
  },
  setDefaultGroundingData: (data) => {
    set((state) => ({ ...state, defaultGroundingData: data }))
  },
  setGroundingCompletionData: (data) => {
    set((state) => ({ ...state, groundingCompletionData: data }))
  },
  setShowTerms: (data) => {
    set((state) => ({ ...state, showTerms: data }))
  },
  setAlreadyConfirmRecall: (data) => {
    set((state) => ({ ...state, alreadyConfirmRecall: data }))
  },
  setAlreadyConfirmGeneralModal: (data) => {
    set((state) => ({ ...state, alreadyConfirmGeneralModal: data }))
  }
}))
